import { POST } from '@/api'
import { isEqual, omit } from 'lodash'

const initialTable = {
  name: '',
  shape: 1,
  smokingType: 0,
  minAvailableSeat: 1,
  maxAvailableSeat: 1,
}

export default {
  namespaced: true,
  state: {
    table: initialTable,
    show: false,
    busy: false,
  },
  getters: {
    changed: ({ table }, _, { tables }) =>
      table.name && !isEqual(table, table.id ? tables.byId[table.id] : initialTable),
  },
  mutations: {
    set(state, table = initialTable) {
      state.table = table
    },
    update(state, table) {
      state.table = { ...state.table, ...table }
    },
    show(state, value) {
      state.show = !!value
    },
    busy(state, value) {
      state.busy = !!value
    },
  },
  actions: {
    async get({ commit, rootState }, id) {
      commit('set', id ? rootState.tables.byId[id] : initialTable)
      commit('show', true)
    },

    async save(store) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST(
        '/api/web/table/regist',
        omit(state.table, ['syncGnaviId', 'hasFutureReservation', 'hasFutureGnaviReservation', 'receptionGroupId']),
      )
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
